import React from 'react'
import { withFormsy } from 'formsy-react'
import ProfileAvatar from './ProfileAvatar'

function ProfileAvatarFormsy(props) {
  const value = props.value

  function setAvatar(input) {
    props.setValue(input)
  }

  return <ProfileAvatar {...props} avatar={value} onAvatarSelect={setAvatar} />
}

export default React.memo(withFormsy(ProfileAvatarFormsy))
